export default {
  methods: {

    validPermission(codigo) {
      if (0 && codigo!='C0001' && codigo!='C0002' && codigo!='C0003' && codigo!='C0005' && codigo!='C0009' )
        {
        return false; 
        }
        
      const user = JSON.parse(localStorage.getItem('user'));
      for (let i = 0; i < user.perfil.permissao.length; i++) {
        if (user.perfil.permissao[i].codigo === codigo && user.perfil.permissao[i].autorizacao) {
          return true;
        }
      }
      return false;
    }
  }
}